import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
// Roboto is the first family in the app's font stack (assets/theme.css) and
// Vuetify's own default. Bundled and served from the app's origin, like the icon
// font, so it needs no third-party host at runtime and the content-security
// policy stays closed to one. Only the weights the interface uses.
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'
// Chrome for the shared dashboard widgets. Imported ahead of the app's own
// stylesheets so app rules still win where they overlap.
import '@signifi/vision-dashboard-ui/widget-chrome.css'
import './assets/print.css';
import './assets/theme.css';
import router from './router'

createApp(App)
  .use(vuetify)
  .use(router)
  .mount('#app')
